import React, { useCallback, useEffect } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import SubmittedClaim from '../../components/submittedClaim/submittedClaim';
import {
    fetchClaimApplicationById,
    fetchClaimApplicationByIdAction,
} from '../../actions';
// @ts-ignore
import { Loader } from 'arag-ui-lib';
import { useAppSelector, useAppDispatch } from '../../hooks/hooks';
import { useTranslation } from 'react-i18next';

const SubmittedClaimContainer = () => {
    const dispatch = useAppDispatch();
    const history = useHistory();
    const { id }: any = useParams();
    const claimApplication = useAppSelector(
        state => state.claimApplication.claimApplication.byId[id],
    );
    const loading = useAppSelector(state => state.claimApplication.loading);
    const { t } = useTranslation();
    const fetchClaimApplicationByIdAction = useCallback(
        (payload: fetchClaimApplicationByIdAction) =>
            dispatch(fetchClaimApplicationById(payload)),
        [dispatch],
    );

    useEffect(() => {
        fetchClaimApplicationByIdAction(id);
    }, [history, id, fetchClaimApplicationByIdAction]);

    const onClaimList = () => history.push('/claims/list');

    if (loading) {
        return (
            <div style={{ marginTop: '50px', marginBottom: '50px' }}>
                <Loader variant={'inline'} label={`${t('loading')}`} />
            </div>
        );
    }

    return (
        <SubmittedClaim
            claimApplication={claimApplication}
            onClaimList={onClaimList}
        />
    );
};

export default SubmittedClaimContainer;
